/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import useCachedQuery from 'lib/useCachedQuery';
import GetLogo from './queries/GetCommunityLogo';
import * as I from 'immutable';
import inIframe from 'lib/inIframe';

function getLogo(data) {
  return I.getIn(data, ['company', 'logo', 'url'], null);
}

function useLogo(id) {
  const o = { variables: { id } };
  const { data, ...rest } = useCachedQuery(GetLogo, o);
  const url = getLogo(data);
  return { ...rest, data: url };
}

const placeholderImg = 'http://placehold.it/100?text=C';

function Logo({ url, href, className, logoStyle }) {
  let img = url ? (
    <img src={url} className={className || ''} style={logoStyle} />
  ) : (
    <img
      src={placeholderImg}
      className="rounded-circle shadow"
      style={logoStyle}
    />
  );
  const isEmbedded = inIframe();
  return href && isEmbedded === false ? <a href={href}>{img}</a> : img;
}

function Loading() {
  return (
    <span
      className="bg-light d-inline-block rounded-circle"
      style={{ width: 100, height: 100 }}
    />
  );
}

function MemberFormLogo({
  id,
  className,
  href,
  logoStyle = {},
  ...rest
}: {
  id?: ID,
  className?: string,
  href?: string,
  logoStyle?: {},
}) {
  const { data: url, loading } = useLogo(id);
  const content = loading ? (
    <Loading />
  ) : (
    <Logo href={href} className={className} url={url} logoStyle={logoStyle} />
  );

  return (
    <div {...rest} data-testid="MemberFormLogo" className="text-center">
      {content}
    </div>
  );
}
export default (MemberFormLogo: any);
